import { RelationshipType } from "@/schemas/user/relationship";
import { formatNumberForDisplay } from "@/formatting/number";

export function formatRelationshipString(
  relationshipType: RelationshipType,
  count: number,
): string {
  const formattedCount = formatNumberForDisplay(count);

  if (relationshipType === RelationshipType.FOLLOWING) {
    return `${formattedCount} following`;
  } else if (relationshipType === RelationshipType.FOLLOWER) {
    return count === 1
      ? `${formattedCount} follower`
      : `${formattedCount} followers`;
  } else {
    return `${formattedCount}`;
  }
}
